import iconChart from 'icon/win10/chart.svg?component'
import iconDefault from 'icon/custom/category-no-icon.svg?component'
import iconEngineer from 'icon/win10/engineer.svg?component'
import iconMaintenance from 'icon/win10/maintenance.svg?component'
import iconShippmentBox from 'icon/win10/shippment-box.svg?component'
import iconSoccer from 'icon/win10/soccer.svg?component'
import iconAdministracao from 'icon/category/administracao.svg?component'
import iconLei from 'icon/category/lei.svg?component'
import iconCalculadora from 'icon/category/calculadora.svg?component'
import iconContabilidade from 'icon/category/contabilidade.svg?component'
import iconCursos from 'icon/category/cursos.svg?component'
import iconDinheiro from 'icon/category/dinheiro.svg?component'
import iconDivida from 'icon/category/divida.svg?component'
import iconRh from 'icon/category/rh.svg?component'
import iconSeguro from 'icon/category/seguro.svg?component'
import iconSistemas from 'icon/category/sistemas.svg?component'
import iconTerceirizacao from 'icon/category/terceirizacao.svg?component'
import iconAntena from 'icon/category/antena.svg?component'
import iconAquecedor from 'icon/category/aquecedor.svg?component'
import iconArcondicionado from 'icon/category/arcondicionado.svg?component'
import iconLazer from 'icon/category/lazer.svg?component'
import iconCobertura from 'icon/category/cobertura.svg?component'
import iconExtintor from 'icon/category/extintor.svg?component'
import iconPragas from 'icon/category/pragas.svg?component'
import iconElevador from 'icon/category/elevador.svg?component'
import iconGas from 'icon/category/gas.svg?component'
import iconLampada from 'icon/category/lampada.svg?component'
import iconInternet from 'icon/category/internet.svg?component'
import iconJardinagem from 'icon/category/jardinagem.svg?component'
import iconFachadalimpa from 'icon/category/fachadalimpa.svg?component'
import iconRaios from 'icon/category/raios.svg?component'
import iconInterfone from 'icon/category/interfone.svg?component'
import iconPortao from 'icon/category/portao.svg?component'
import iconCamera from 'icon/category/camera.svg?component'
import iconSustentabilidade from 'icon/category/sustentabilidade.svg?component'
import iconArquitetura from 'icon/category/arquitetura.svg?component'
import iconObra from 'icon/category/obra.svg?component'
import iconEngenheiro from 'icon/category/engenheiro.svg?component'
import iconVagas from 'icon/category/vagas.svg?component'
import iconImpermeabilizacao from 'icon/category/impermeabilizacao.svg?component'
import iconSerra from 'icon/category/serra.svg?component'
import iconEletrica from 'icon/category/eletrica.svg?component'
import iconHidraulica from 'icon/category/hidraulica.svg?component'
import iconPintura from 'icon/category/pintura.svg?component'
import iconSolda from 'icon/category/solda.svg?component'
import iconJanela from 'icon/category/janela.svg?component'
import iconLavanderia from 'icon/category/lavanderia.svg?component'
import iconFesta from 'icon/category/festa.svg?component'
import iconGinastica from 'icon/category/ginastica.svg?component'
import iconAgua from 'icon/category/agua.svg?component'
import iconCone from 'icon/category/cone.svg?component'
import iconTapete from 'icon/category/tapete.svg?component'
import iconCarrinho from 'icon/category/carrinho.svg?component'
import iconJogos from 'icon/category/jogos.svg?component'
import iconCapacete from 'icon/category/capacete.svg?component'
import iconLimpeza from 'icon/category/limpeza.svg?component'
import iconLixeira from 'icon/category/lixeira.svg?component'
import iconMaquina from 'icon/category/maquina.svg?component'
import iconMoveis from 'icon/category/moveis.svg?component'
import iconPiscina from 'icon/category/piscina.svg?component'
import iconLata from 'icon/category/lata.svg?component'
import iconPlaca from 'icon/category/placa.svg?component'

export const groupIcon = (name) => ({
  'Administração e Jurídico': iconChart,
  'Manutenção e Prevenção': iconMaintenance,
  'Obras e Reformas': iconEngineer,
  'Conveniência e Atividades': iconSoccer,
  'Produtos e Acessórios': iconShippmentBox,
}[name] || iconDefault)

export const categoryIcon = (name) => ({
  'Administração': iconAdministracao,
  'Jurídico': iconLei,
  'Auditoria': iconCalculadora,
  'Contabilidade': iconContabilidade,
  'Cursos e treinamentos': iconCursos,
  'Finanças': iconDinheiro,
  'Inadimplência': iconDivida,
  'RH e medicina do trabalho': iconRh,
  'Seguros': iconSeguro,
  'Sistemas e aplicativos': iconSistemas,
  'Terceirização de serviços': iconTerceirizacao,
  'Antenas': iconAntena,
  'Aquecedores': iconAquecedor,
  'Ar-condicionado': iconArcondicionado,
  'Áreas de lazer': iconLazer,
  'Coberturas e telhados': iconCobertura,
  'Combate a incêndio': iconExtintor,
  'Controle de pragas': iconPragas,
  'Elevadores': iconElevador,
  'Elétrica': iconEletrica,
  'Gás': iconGas,
  'Hidráulica e água': iconHidraulica,
  'Iluminação': iconLampada,
  'Internet e redes': iconInternet,
  'Jardinagem': iconJardinagem,
  'Limpeza': iconFachadalimpa,
  'Para-raios': iconRaios,
  'Portaria': iconInterfone,
  'Portas e janelas': iconJanela,
  'Portões': iconPortao,
  'Sistemas de segurança e acesso': iconCamera,
  'Sustentabilidade': iconSustentabilidade,
  'Arquitetura e projetos': iconArquitetura,
  'Construção e reformas': iconObra,
  'Engenharia': iconEngenheiro,
  'Garagens e estacionamentos': iconVagas,
  'Impermeabilização': iconImpermeabilizacao,
  'Marcenaria': iconSerra,
  'Obras de gás': iconGas,
  'Obras elétricas': iconEletrica,
  'Obras hidráulicas': iconHidraulica,
  'Pinturas e restaurações': iconPintura,
  'Serralheria': iconSolda,
  'Vidraçaria': iconJanela,
  'Conveniência': iconLavanderia,
  'Eventos': iconFesta,
  'Saúde e lazer': iconGinastica,
  'Bebedouros e filtros': iconAgua,
  'Bicicletários e garagem': iconCone,
  'Capachos e acolchoados': iconTapete,
  'Carrinhos e containers': iconCarrinho,
  'Esporte e diversão': iconJogos,
  'Funcionários e acessórios': iconCapacete,
  'Iluminação e acessórios': iconLampada,
  'Limpeza e descartáveis': iconLimpeza,
  'Lixeiras e cinzeiros': iconLixeira,
  'Máquinas e ferramentas': iconMaquina,
  'Móveis e organizadores': iconMoveis,
  'Piscinas e saunas': iconPiscina,
  'Materiais de construção': iconLata,
  'Segurança e equipamentos': iconCamera,
  'Sinalização e Placas': iconPlaca,
}[name] || iconDefault)

export default groupIcon
